function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, React.createElement("path", {
  d: "M1135.18 200.092c-1.651-1.62-3.843-2.542-6.161-2.542-2.001 0-3.97.668-5.526 1.939-3.78-3.05-9.306-2.479-12.355 1.302-2.255 2.796-2.572 6.736-.794 9.85h4.256l4.415-7.657 2.89 8.77 3.24-5.752 2.73 4.671h2.605c.54 0 .952.413.952.953s-.412.953-.952.953h-3.684l-1.62-2.732-3.748 6.577-2.922-8.801-2.826 4.925h-3.875l11.688 11.693 11.75-11.757c3.399-3.431 3.367-8.992-.063-12.392z",
  id: "heart_icon_svg__a"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-1109 -197)"
}, React.createElement("use", {
  xlinkHref: "#heart_icon_svg__a",
  fill: "#a2a2a2"
}));

var SvgHeartIcon = function SvgHeartIcon(props) {
  return React.createElement("svg", _extends({
    width: 29,
    height: 27,
    viewBox: "0 0 29 27"
  }, props), _ref, _ref2);
};

export default SvgHeartIcon;